import Animation from "../animation";

export default class Accordion {
  constructor() {
    this.accordions = document.querySelectorAll('.accordion');
    if (this.accordions.length === 0) return;

    this.init();
  }

  init() {
    this.accordions.forEach(accordion => {
      accordion.querySelector('.accordion__head').addEventListener('click', () => {
        accordion.querySelector('.accordion__trigger').classList.toggle('is-active')
        accordion.querySelector('.accordion__content').classList.toggle('is-active')
        accordion.classList.toggle('is-active')
        if (accordion.classList.contains('accordion--countup') && !this.animation) {
          this.initCountUp(accordion);
        }
      })
    })
  }

  initCountUp(accordion) {
    let countUpItems = accordion.querySelectorAll('[data-hook=accordion-countup]');

    this.animation = new Animation(null, false);
    this.animation.initCountUps(countUpItems);
  }
}

